import { initWebTracing } from '@nava/otel-tracing-web';
import { getRuntimeConfigValue } from './runtime-config';

try {
  const raw = getRuntimeConfigValue('VITE_BFF_URL');
  const origin = import.meta.env.DEV
    ? window.location.origin
    : raw
      ? new URL(raw).origin
      : undefined;
  if (origin)
    initWebTracing({
      serviceName: 'backoffice-client',
      environment: getRuntimeConfigValue('VITE_APP_ENV') ?? 'local',
      enabled:
        getRuntimeConfigValue('VITE_OTEL_TRACING_ENABLED') === '1' &&
        import.meta.env.MODE !== 'test',
      bffOrigin: origin,
      otlpEndpoint: `${origin}/api/backoffice/diagnostics/traces`,
    });
} catch {
  /* Telemetry configuration must never prevent application startup. */
}
